"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var InstagramBox = function InstagramBox(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/instagram_box-instagram-box" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "fill-1-instagram-box" + unique,
    xlinkHref: "#path-1-instagram-box" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-instagram-box" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M14.746461,18.9772915 C16.9186731,18.9772915 18.6959163,17.2000191 18.6959163,15.0278071 L18.6959163,8.97858462 C18.6959163,6.80637256 16.9186731,5.02910021 14.746461,5.02910021 L9.06950467,5.02910021 C6.8972635,5.02910021 5.11999115,6.80637256 5.11999115,8.97858462 L5.11999115,15.0278071 C5.11999115,17.2000191 6.8972635,18.9772915 9.06950467,18.9772915 L14.746461,18.9772915 Z M14.7464319,17.9336948 L9.06950467,17.9336948 C8.29767099,17.9336948 7.56914708,17.6302062 7.01811174,17.0792 C6.46707639,16.5281647 6.16361693,15.7996407 6.16361693,15.0278071 L6.16361693,8.97858462 C6.16361693,8.20678004 6.46707639,7.47822703 7.01811174,6.92722079 C7.56914708,6.37618545 8.29767099,6.07272599 9.06950467,6.07272599 L14.7464319,6.07272599 C15.5182656,6.07272599 16.2467895,6.37618545 16.7977957,6.92722079 C17.3488311,7.47822703 17.6522905,8.20678004 17.6522905,8.97858462 L17.6522905,15.0278071 C17.6522905,15.7996407 17.3488311,16.5281647 16.7977957,17.0792 C16.2467895,17.6302062 15.5182656,17.9336948 14.7464319,17.9336948 Z M15.6673467,11.949338 C15.6673467,9.88470187 13.9936045,8.21095967 11.9289392,8.21095967 C9.8642739,8.21095967 8.1905608,9.88470187 8.1905608,11.949338 C8.1905608,14.0140033 9.8642739,15.6877455 11.9289392,15.6877455 C13.9936045,15.6877455 15.6673467,14.0140033 15.6673467,11.949338 Z M11.9109517,9.50437339 C13.2628976,9.50437339 14.3588851,10.6003609 14.3588851,11.9523069 C14.3588851,13.3042819 13.2628976,14.4002694 11.9109517,14.4002694 C10.5589766,14.4002694 9.46301818,13.3042819 9.46301818,11.9523069 C9.46301818,10.6003609 10.5589766,9.50437339 11.9109517,9.50437339 Z M16.6125446,8.15281746 C16.6125446,7.6639526 16.2162369,7.2676158 15.727372,7.2676158 C15.2384781,7.2676158 14.8421704,7.6639526 14.8421704,8.15281746 C14.8421704,8.64168233 15.2384781,9.03801913 15.727372,9.03801913 C16.2162369,9.03801913 16.6125446,8.64168233 16.6125446,8.15281746 Z",
    fill: "inherit",
    id: "path-1-instagram-box" + unique
  }))));
};

InstagramBox.propTypes = propTypes;
var _default = InstagramBox;
exports["default"] = _default;